<template>
  <div class="row pt-1" v-if="berechtigungen.b_bildung_bildungsportfolio.read">
    <div class="col-lg-12">
      <div class="tile-categorie-frame">
        <div class="tile-categorie">
          <div class="header">
            <span>{{ $t("dashboard.subsidies") }}</span>
          </div>
          <div class="body">
            <div class="row">
              <div :class="kachelCol">
                <div class="tile-frame h-1" :class="kachelStyle">
                  <router-link :to="{ name: 'subventionsliste' }">
                    <div class="tile bg-dark-blue inverted">
                      <div class="icon-container fa-container">
                        <font-awesome-icon
                          icon="fa-duotone fa-address-book"
                          transform="shrink-2"
                        />
                      </div>
                      <div class="title">
                        {{ $t("dashboard.subsidies") }}
                      </div>
                    </div>
                  </router-link>
                </div>
              </div>
              <div :class="kachelKleinCol">
                <div class="tile-frame h-1" :class="kachelKleinStyle">
                  <router-link :to="{ name: 'subventionsbeitragliste' }">
                    <div class="tile bg-dark-blue inverted">
                      <div class="icon-container fa-container">
                        <font-awesome-icon
                          icon="fa-duotone fa-address-book"
                          transform="shrink-2"
                        />
                      </div>
                      <div class="title">
                        {{ $t("dashboard.subsidycontributions") }}
                      </div>
                    </div>
                  </router-link>
                </div>
              </div>
              <div :class="kachelKleinCol">
                <div class="tile-frame h-1" :class="kachelKleinStyle">
                  <router-link :to="{ name: 'subventionsabrechnungliste' }">
                    <div class="tile bg-dark-blue inverted">
                      <div class="icon-container fa-container">
                        <font-awesome-icon
                          icon="fa-duotone fa-address-book"
                          transform="shrink-2"
                        />
                      </div>
                      <div class="title">
                        {{ $t("dashboard.settlements") }}
                      </div>
                    </div>
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
//import { defineComponent } from '@vue/composition-api'

export default {
  name: "StartseiteSubventionen",
  components: {},
  mixins: [],
  props: {
    kachelStyle: { type: String },
    kachelCol: { type: String },
    kachelKleinStyle: { type: String },
    kachelKleinCol: { type: String },
  },
  data() {
    return {};
  },
  created() {},
  mounted() {},
  computed: {},
  methods: {},
};
</script>
